import Footer from "../../components/footer"
import Header from "../../components/header"
import Grid from '@material-ui/core/Grid';
import {MyContainer} from '../../components/common/MyContainer'
import Sidebar from "./sidebar";
import { Switch, Route, Redirect, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress';
import { FixedLoading } from "../../components/newsForm/newsFormElements";
import {BorderLeft} from './meElements'
import { useEffect } from 'react'
import NewsSaved from "./newsSaved";
import UserComments from "./userComments";
import Account from "./account";

const Me = ({match}) => {
    const { user, isLoading } = useSelector(state => state.user)
    const history = useHistory()
    
    
    useEffect(() => {
        if(Object.keys(user).length === 0 && !isLoading) history.push('/')
    }, [user, history, isLoading])

    return (
        <>
            <Header hidebanner menuMt />
            {isLoading && <FixedLoading><CircularProgress color="secondary" /></FixedLoading>}
            {!isLoading && 
                <MyContainer>
                    <Grid container>
                        <Grid className='hide-on-mobile-tablet' item xs={3}>
                            <Sidebar />
                        </Grid>
                        <Grid item xs={12} md={12} lg={9}>
                            <BorderLeft>
                                <Switch>
                                    <Route exact path={`${match.url}/news`}>
                                        <NewsSaved />
                                    </Route>
                                    <Route exact path={`${match.url}/comments`}>
                                        <UserComments />
                                    </Route>
                                    <Route exact path={`${match.url}/account`}>
                                        <Account />
                                    </Route>
                                    <Route>
                                        <Redirect to={`${match.url}/news`} />
                                    </Route>
                                </Switch>
                            </BorderLeft>
                        </Grid>
                    </Grid>
                </MyContainer>
            }
            <Footer />
        </>
    )
}

export default Me
